:root {
    // Spacing Rules
    --xsmall: 1rem;
    --small: 1.125rem;
    --medium: 1.5rem;
    --large: 2rem;
    --xlarge: 3rem;
}

// Top Outer
.topXSmall {
    margin-top: var(--xsmall);
}

.topSmall {
    margin-top: var(--small);
}

.topMedium {
    margin-top: var(--medium);
}

.topLarge {
    margin-top: var(--large);
}

.topXLarge {
    margin-top: var(--xlarge);
}

// Top Inner
.topInnerXSmall {
    padding-top: var(--xsmall);
}

.topInnerSmall {
    padding-top: var(--small);
}

.topInnerMedium {
    padding-top: var(--medium);
}

.topInnerLarge {
    padding-top: var(--large);
}

.topInnerXLarge {
    padding-top: var(--xlarge);
}

// Bottom Outer
.bottomXSmall {
    margin-bottom: var(--xsmall);
}

.bottomSmall {
    margin-bottom: var(--small);
}

.bottomMedium {
    margin-bottom: var(--medium);
}

.bottomLarge {
    margin-bottom: var(--large);
}

.bottomXLarge {
    margin-bottom: var(--xlarge);
}

// Bottom Inner
.bottomInnerXSmall {
    padding-bottom: var(--xsmall);
}

.bottomInnerSmall {
    padding-bottom: var(--small);
}

.bottomInnerMedium {
    padding-bottom: var(--medium);
}

.bottomInnerLarge {
    padding-bottom: var(--large);
}

.bottomInnerXLarge {
    padding-bottom: var(--xlarge);
}
